/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedCollectionsModulesHeroModule_collectionsModules$ref = any;
export type SbSharedCollectionsModulesHeroModule_collectionsModules = {
    readonly photo: string | null;
    readonly title: string | null;
    readonly subtitle: string | null;
    readonly description: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly variation: string | null;
    readonly " $refType": SbSharedCollectionsModulesHeroModule_collectionsModules$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedCollectionsModulesHeroModule_collectionsModules",
    "type": "CollectionsModulesHero",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "photo",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "subtitle",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "link",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "linkText",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "variation",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '64de9460e16b80077624d14d3dacd8c2';
export default node;
